import { auth } from "./firebase";
const isdev = false;

const API_BASE = isdev ? "http://localhost:3001" : "https://agilegpsbackend-dot-ind-iusm-chiis-sw-dev.uc.r.appspot.com";

async function getIdToken() {
  const user = auth.currentUser;
  if (!user) throw new Error("Not logged in");
  return await user.getIdToken(); // refresh handled by firebase
}

export async function apiFetch(path, { method = "GET", body } = {}) {
  const token = await getIdToken();
  const resp = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    const msg = data?.message || `Request failed (${resp.status})`;
    const err = new Error(msg);
    err.status = resp.status;
    err.data = data;
    throw err;
  }
  return data;
}